<div class="dropdown-content">
  <ng-content></ng-content>
</div>
